import AppDispatcher from "../Dispatcher";
import AppSDK from "@growthos/ui-app-sdk";
import { AppActionConstants } from "./AppActionConstants";
import AppConfig from "../../AppConfig";
import { fetchWithAuthGet, fetchWithAuthPost } from "../FetchWithAuth";
import BookFiltersStore from "../Stores/BookFiltersStore";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";

const basePath = AppConfig.getBookApiBasePath();

export const fetchInsertionOrders = (config, campaignUniqueID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return Promise.all([
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/TaxonomyConfiguration/getHeaders/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}`
		),
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
		)
	]).then((response) => {
		const config = response[0];
		const data = response[1];
		// do something with both responses
		const insertionOrderData = {
			config,
			data
		};
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchInsertionOrders,
			value: insertionOrderData
		});
	});
};

export const fetchOnlyInsertionOrders = (config, campaignUniqueID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
	).then((response) => {
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchOnlyInsertionOrders,
			value: response
		});
	});
};

export const putInsertionOrder = (data, promptForChildren, clone, createDuplicateChildren = null) => {
	/* API ENDPOINT /Book2API/custom/InsertMasterCampaign */

	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	let type = AppActionConstants.createInsertionOrderSuccess;
	if (promptForChildren === true) {
		type = AppActionConstants.createAndAddInsertionOrderSuccess;
	}
	if (createDuplicateChildren !== null) {
		type = AppActionConstants.createChildLineItems;
	}
	let cloneIO = false;
	if (clone) {
		cloneIO = true;
	}
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/InsertionOrderSaveViewModel/InsertUpdateInsertionOrders`, postData)
		.then((resp) => {
			if (createDuplicateChildren !== null) {
				createDuplicateChildren(resp[1].Object);
			}
			AppDispatcher.dispatch({
				type,
				value: resp[1].Object,
				cloneIO
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.createInsertionOrderFail,
				value: errorObject[1].Object,
				cloneIO
			});
		});
};

export const editInsertionOrder = (data, row) => {
	/* API ENDPOINT /Book2API/custom/InsertMasterCampaign */

	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/InsertionOrderSaveViewModel/InsertUpdateInsertionOrders`, postData)
		.then((resp) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.editInsertionOrderSuccess,
				value: resp[1].Object,
				row
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.editInsertionOrderFail,
				value: errorObject[1].Object
			});
		});
};

export const updateInsertionOrdersSheet = (postData, createLineItems) => {
	const user = AppSDK.ApiUser.getUser();
	postData.FirstName = user?.givenName;
	postData.LastName = user?.familyName;
	postData.Email = user?.userName;

	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/InsertionOrderSaveViewModel/InsertUpdateInsertionOrders`, JSON.stringify(postData)).then((resp) => {
		if (typeof createLineItems === "function") {
			createLineItems(resp);
		}
		return resp;
	});
};

export const setFilteredData = (data) => {
	AppDispatcher.dispatch({
		type: AppActionConstants.setFilteredInsertionOrders,
		value: data
	});
};

export const deleteInsertionOrders = (data, deletedIDs, onFailure) => {
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/InsertionOrderSaveViewModel/DeleteInsertionOrders`, JSON.stringify(data))
		.then((resp) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.deleteInsertionOrderSuccess, // "EDITPACKAGESSUCCESS"
				value: resp,
				deletedIDs
			});
		})
		.catch((error) => {
			ErrorHelpers.displayErrorToasts(error, "workbookToasts", `Insertion Order${deletedIDs?.length > 1 ? "s" : ""} could not be deleted.`);
			onFailure();
		});
};

export const pushIOToDV360 = (insertionOrderIDs) => {
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/Placement/AddInsertionOrdersToDV360`, JSON.stringify({ InsertionOrderIDS: insertionOrderIDs }));
};

export const updateIOSyncStatus = (insertionOrderIDs) => {
	AppDispatcher.dispatch({
		type: AppActionConstants.updateIOSyncStatus,
		value: insertionOrderIDs
	});
};
